<template>
  <modal name="item-display-modify-modal" class="item-display-modify-modal dgm-modal"
         :width="500"
         :height="'auto'"
        @before-close="beforeClose"
  >
    <div class="pa20" v-loading="modalLoading">
        <div class="sub_title">일괄설정</div>
        <div class="c_table_wrap ">
            <el-checkbox-group v-model="updateList">

                <table>
                    <colgroup>
                        <col width="200px;">
                        <col width="">
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="c_t_title has_check">
                            <div>
                                <el-checkbox :label="'i_display'">{{''}}</el-checkbox>
                                진열상태
                            </div>
                        </td>
                        <td>
                            <el-select v-model="i_display" :disabled="!checkSelectUpdate('i_display')" @change="errorMsg=''">
                                <el-option
                                        :label="'진열함'"
                                        :value="1"
                                ></el-option>
                                <el-option
                                        :label="'진열안함'"
                                        :value="0"
                                ></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title has_check">
                            <div>
                                <el-checkbox :label="'ie_pattern'">{{''}}</el-checkbox>
                                패턴
                            </div>
                        </td>
                        <td>
                            <el-select v-model="ie_pattern" placeholder="패턴선택" :disabled="!checkSelectUpdate('ie_pattern')"  @change="errorMsg=''">
                                <el-option v-for="(item, index) in PatternList" :key="index" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title has_check">
                            <div>
                                <el-checkbox :label="'ie_season'">{{''}}</el-checkbox>
                                시즌
                            </div>
                        </td>
                        <td>
                            <el-select v-model="ie_season" placeholder="시즌선택" :disabled="!checkSelectUpdate('ie_season')" @change="errorMsg=''">
                                <el-option v-for="(item, index) in SeasonList" :key="index" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title has_check">
                            <div>
                                <el-checkbox :label="'ic_idx'">{{''}}</el-checkbox>
                                상품분류
                            </div>
                        </td>
                        <td>
                            <div class="">
                                <el-select
                                        v-model="CateDepth1"
                                        :disabled="!checkSelectUpdate('ic_idx')"
                                        placeholder="대분류"
                                        class="table_s_select mb10"
                                        @change="SetSubCate(1, CateDepth1, SelCateList[0])"
                                >
                                    <el-option
                                            v-for="(item, index) in SelCateList[0]"
                                            :key="index"
                                            :label="item.NAME"
                                            :value="item.PKEY">
                                    </el-option>
                                </el-select>
                                <el-select
                                        v-model="CateDepth2"
                                        :disabled="!checkSelectUpdate('ic_idx')"
                                        placeholder="중분류"
                                        class="table_s_select mb10"
                                        @change="SetSubCate(2, CateDepth2, SelCateList[1])"
                                >
                                    <el-option
                                            v-for="(item, index) in SelCateList[1]"
                                            :key="index"
                                            :label="item.NAME"
                                            :value="item.PKEY">
                                    </el-option>
                                </el-select>
                                <el-select
                                        v-model="CateDepth3"
                                        :disabled="!checkSelectUpdate('ic_idx')"
                                        placeholder="소분류"
                                        class="table_s_select mb10"
                                        @change="SetSubCate(3, CateDepth3, SelCateList[2])"
                                >
                                    <el-option
                                            v-for="(item, index) in SelCateList[2]"
                                            :key="index"
                                            :label="item.NAME"
                                            :value="item.PKEY">
                                    </el-option>
                                </el-select>
                                <el-select
                                        v-model="CateDepth4"
                                        :disabled="!checkSelectUpdate('ic_idx')"
                                        placeholder="상세분류"
                                        class="table_s_select"
                                        @change="setCategory()"
                                >
                                    <el-option
                                            v-for="(item, index) in SelCateList[3]"
                                            :key="index"
                                            :label="item.NAME"
                                            :value="item.PKEY">
                                    </el-option>
                                </el-select>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </el-checkbox-group>
        </div>
        <div class="input_error pt5" v-show="errorMsg != ''">{{errorMsg}}</div>
        <div class="mt20 text_center">
            <el-button type="primary" @click="checkValidator()">일괄설정</el-button>
            <el-button @click="closeModal()">닫기</el-button>
        </div>
    </div>
  </modal>

</template>

<script>
import VuxAlert from '@/mixins/alertMixins';
import EventBus from "@/mixins/event-bus.js"
import {PatternList, SeasonList} from "@/service/itemService";
import util from "@/mixins/util";
import {elasticOption} from "@/api/config";
import {isDev} from "@/api/config";

export default {
    name: 'ItemDisplayModifyModal',
    props: {
        selectItems: {
            type: Array,
            default: [],
        },
    },
    components: {
    },
    mixins: [VuxAlert],
    computed: {

    },
    data() {
        return{
            modalLoading: false,
            i_display: 0,
            ie_pattern: '',
            ie_season: '',
            ic_idx: '',
            CateDepth1: '',
            CateDepth2: '',
            CateDepth3: '',
            CateDepth4: '',
            SelCateList : [
                [],
                [],
                [],
                []
            ],
            TotalCateList: [],
            updateList: ['i_display', 'ie_pattern', 'ie_season', 'ic_idx'],
            PatternList: PatternList,
            SeasonList: SeasonList,
            errorMsg: '',

        }
    },
    mounted() {
        this.getCategory();
    },
    methods: {
        initData() {
            this.modalLoading = false;
            this.i_display = 0;
            this.ie_pattern = '';
            this.ie_season = '';
            this.ic_idx = '';
            this.CateDepth1= '';
            this.CateDepth2 = '';
            this.CateDepth3 = '';
            this.CateDepth4 = '';
            this.SelCateList = [
                this.TotalCateList,
                [],
                [],
                []
            ];
            this.updateList= ['i_display', 'ie_pattern', 'ie_season', 'ic_idx'];
            this.errorMsg = '';
        },
        checkSelectUpdate(key) {
            return this.updateList.indexOf(key) > -1;
        },
        SetSubCate(index, idx, array) {
            this.errorMsg = '';
            let item = {};
            for(let i = 0 ; i < array.length ; i++) {
                if(array[i].PKEY === idx) {
                    item = array[i]
                    break;
                }
            }
            for(let i = index ; i < this.SelCateList.length ; i ++) {
                this.SelCateList[i] = [];
            }
            if(item.hasOwnProperty('child')) {
                this.SelCateList[index] = item.child;
            }
            this.$forceUpdate();
        },
        setCategory() {
            this.errorMsg = '';
            this.ic_idx = this.CateDepth4;
        },
        itemValidator() {
            util.Array.each(this.updateList, (obj, index, arr) => {
                if(util.isEmpty(this[obj]) && this.errorMsg === '') {
                    this.errorMsg = this.returnErrorMsg(obj);
                }
            });
            return this.errorMsg === '' ? true : false;
        },
        returnErrorMsg(key) {
            switch (key) {
                case 'i_display':
                    return '진열상태를 선택해주세요.';
                case 'ie_pattern':
                    return '패턴을 선택해주세요.';
                case 'ie_season':
                    return '시즌을 선택해주세요.';
                case 'ic_idx':
                    return '상품분류를 선택해주세요.';
                default:
                    return '설정값을 입력해주세요.';
            }
        },
        getCategory() {
            this.$api.$item.getItemCategory().then(res => {
                this.TotalCateList = res.Data.Result.List;
                this.SelCateList[0] = this.TotalCateList;
                this.$forceUpdate();
            })
        },
        checkValidator() {
            if(this.itemValidator()) {
                this.updateItem()
            }
        },
        updateItem(index=0) {
            this.modalLoading = true;
            let params = {
                i_type: 'eot',
                i_idx : this.selectItems[index].i_idx,
            };
            util.Array.each(this.updateList, (obj, index, arr) => {
                params[obj] = this[obj];
            });
            this.$api.$item.updateItem(params).then(res => res.Data.Result).then(res => {
                if(res.List.Data.Data.Basic.Status === true) {
                    let elasticParams = {
                        i_idx: this.selectItems[index].i_idx,
                        index : elasticOption.index,
                    }
                    if(!isDev) {
                        this.$api.$item.indexingItem(elasticParams).then(elaRes => {
                            if(elaRes.Data.Result.Info.Type != 1) {
                                let alertContent = `전체 ${this.selectItems.length}개의 상품중에 ${index}개가 수정되었습니다.`;
                                this.finishUpdate(alertContent)
                            }else {
                                if(index+1 === this.selectItems.length) {
                                    let alertContent = '상품 일괄수정이 완료되었습니다.';
                                    this.finishUpdate(alertContent)
                                }else{
                                    this.updateItem(index+1);
                                }
                            }
                        })
                    }else {
                        if(index+1 === this.selectItems.length) {
                            let alertContent = '상품 일괄수정이 완료되었습니다.';
                            this.finishUpdate(alertContent)
                        }else{
                            this.updateItem(index+1);
                        }
                    }
                }else{
                    let alertContent = `전체 ${this.selectItems.length}개의 상품중에 ${index}개가 수정되었습니다.`;
                    this.finishUpdate(alertContent)
                }
            });
        },
        finishUpdate(alertContent) {
            this.modalLoading = false;
            this.createAlert({
                title: '',
                content: alertContent,
                btnText: "확인",
                hide :() => {
                    EventBus.$emit('elasticListGetList');
                    this.closeModal();
                }
            });
        },
        beforeClose() {
            this.initData();
        },
        closeModal() {
            this.$modal.hide('item-display-modify-modal')
        }
    }
}
</script>
